import React, { useEffect, useState } from 'react';
import { postMessage } from "../services/api";

import CaptchaComponent from '../components/CaptchaComponent';
import ChatHeader from '../components/CommonComponents/ChatHeader';
import ChatSidebar from '../components/CommonComponents/ChatSidebar';
import Disclaimer from '../components/CommonComponents/Disclaimer';
import MessageInput from '../components/MessageInput';
import LoaderPage from '../components/CommonComponents/Loader/LoaderPage';


declare global {
  interface Window {
    grecaptcha: {
      ready: (callback: () => void) => void;
      execute: (siteKey: string, options: { action: string }) => Promise<string>;
    };
  }
}


const Home: React.FC = () => {
  const [captchaVerified, setCaptchaVerified] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);


  useEffect(() => {
    document.title = "AskWellie | Home";

    const verifyRecaptcha = async () => {
      try {
        const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";
        if (!RECAPTCHA_SITE_KEY) {
          throw new Error("reCAPTCHA site key is missing");
        }
        const style = document.createElement('style');
        style.innerHTML = `#webpack-dev-server-client-overlay { display: none !important; }`;
        document.head.appendChild(style);
        (window as any).grecaptcha.ready(() => {
          (window as any).grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: "submit" })
            .then(async (token: string) => {
              const response = await postMessage("/api/verify_recaptcha", { recaptcha_token: token }, false);
              setLoading(false)
              if (response.success) {
                setCaptchaVerified(true);
              }
              else {
                setCaptchaVerified(false);
              }
            })
            .catch((error: any) => {
              setCaptchaVerified(false);
            });
        });
      }
      catch (error: any) {
        setCaptchaVerified(false);
      }
    };

    verifyRecaptcha();
  }, []);

  if (loading) {
    return (
      <div>
        <ChatHeader />
        <div className="chat-row-container flex-columns columns-full">
          <ChatSidebar />
          <main className="max-w-4xl mx-auto p-6 h-100dvh">
            <div className="not-found-container">
              <LoaderPage />
            </div>
          </main>
        </div>
        <Disclaimer />
      </div>)
  }
  return (
    <>
      <div className="chat-container">
        <ChatHeader />
        <div className="chat-row-container flex-columns columns-full">
          <ChatSidebar />
          {!captchaVerified ? (
            <CaptchaComponent onVerify={() => setCaptchaVerified(true)} />
          ) : (
            <MessageInput />
          )}
        </div>
        <Disclaimer />
      </div>
    </>
  );
};

export default Home;
